//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      redirect:'',
      sdomain:'',
      choose:[
        {
          label:'开启重定向',
          value:'open'
        },
        {
          label:'关闭重定向',
          value:'close'
        },
      ]
    }
  },
  mounted(){
    this.ErrorQuery()
  },
  methods: {
    Choose(id) {
      this.redirect = id
    },
    ErrorQuery() {
      let data = 'cmd=vhost_basic'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/vhost.php', data).then(({data}) => {
        if(data) {
          this.redirect = data.Pstate === '20' ? 'open' : 'close'
          this.sdomain = data.RedirectURL
        }
      })
    },
    submit() {
      let data;
      if(this.redirect === 'open'){
        let url = this.sdomain
        if(this.redirect.indexOf('http://') == -1 && this.redirect.indexOf('https://') == -1){
          url = 'http://' + this.sdomain
        }
        data = 'cmd=web301'+
          '&id='+ this.$route.params.id +
          '&cmdtype='+ this.redirect +
          '&url='+ url
      }
      if(this.redirect === 'close'){
        data = 'cmd=web301'+
          '&id='+ this.$route.params.id +
          '&cmdtype='+ this.redirect
      }
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostoperate/redirecturl.vue